import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * 기본 로그 API
 */
export default {
  /**
   * 로그 트리 데이터를 조회한다.
   * @author Ju
   * @return {Object} [axios response]
   */
  getLogTree() {
    return axios.get(`${baseUrl}/log/config/get-log-tree.do`);
  },
  /**
   * [로그분석 > 조회] 그리드 데이터를 조회한다.
   * @author Minyeong
   * @param  {Object}  params [description]
   * @return {Object}        [description]
   */
  getLogAnalysisData(params) {
    return axios.post(`${baseUrl}/log/analysis/get-log-list.do`, params);
  },
  /**
   * [로그분석 > 조회] 로그의 검색 필드 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogFilterFieldOptions() {
    return axios.get(`${baseUrl}/log/filter/get-log-filter-field-options.do`);
  },
  /**
   * [로그분석 > 사용자 정의 필터] 사용자 정의 필터의 정보를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [트리에서 선택된 사용자 정의 필터의 filterId]
   * @return {[type]}        [description]
   */
  getLogFilter(params) {
    return axios.get(`${baseUrl}/log/filter/get-log-filter.do`, params);
  },
  /**
   * [로그분석 > 사용자 정의 필터] 사용자 정의 로그 필터를 추가한다.
   * @author Minyeong
   * @param  {[type]} params [필터 정보 객체]
   * @return {[type]}        [description]
   */
  insertLogFilter(querystring, payload) {
    return axios.post(`${baseUrl}/log/filter/insert-log-filter.do?${querystring}`, payload);
  },
  /**
   * [로그분석 > 사용자 정의 필터] 사용자 정의 로그 필터를 수정한다.
   * @author Minyeong
   * @param  {[type]} querystring [필터 정보 객체]
   * @param  {[type]} payload     [description]
   * @return {[type]}             [description]
   */
  updateLogFilter(querystring, payload) {
    return axios.post(`${baseUrl}/log/filter/update-log-filter.do?${querystring}`, payload);
  },
  /**
   * [로그분석 > 사용자 정의 필터] 사용자 정의 로그 필터를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [삭제할 필터의 filterId]
   * @return {[type]}        [description]
   */
  deleteLogFilter(params) {
    return axios.post(`${baseUrl}/log/filter/delete-log-filter.do`, params);
  },
  /**
   * [로그분석 > 조회] 로그 상세보기 팝업의 차트 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getLogDetailChartData(params) {
    return axios.post(`${baseUrl}/log/analysis/get-log-detail-chart-data.do`, params);
  },
  /**
   * [로그분석 > 조회] 로그의 상태를 '확인'으로 변경한다.
   * @author Minyeong
   * @param  {[Array]} params [변경할 로그의 데이터 객체]
   * @return {[type]}        [description]
   */
  updateLogIsChecked(params) {
    return axios.post(`${baseUrl}/log/analysis/update-log-is-checked.do`, params);
  },
  /**
   * [성능/운영 > 분석 > 로그] 현재 검색조건의 모든 로그의 상태를 '확인'으로 일괄 변경한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateAllLogIsChecked(params) {
    return axios.post(`${baseUrl}/log/analysis/update-all-log-is-checked.do`, params);
  },
  /**
   * [로그분석> 키워드맵] 단어연관 차트 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getWordChart(params) {
    return axios.post(`${baseUrl}/log/analysis/get-word-chart.do`, params);
  },
  /**
   * snmpTrap 이름을 가져온다
   * @author leesy918
   * @param  {[type]} queryString [description]
   * @return {[type]}             [description]
   */
  getSnmpTrapName(queryString) {
    return axios.get(`${baseUrl}/log/analysis/get-snmp-trap-name.do?${queryString}`);
  },
};



// WEBPACK FOOTER //
// ./src/api/log/common.js